import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ISelectOptions, SELECT_ALL_ITEMS_VALUE } from '../../../shared/services/pagination.service';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-pagination',
    templateUrl: './pagination.component.html',
    styleUrl: './pagination.component.scss',
    standalone: false
})
export class PaginationComponent {
  allItemsSelectedValue = SELECT_ALL_ITEMS_VALUE;

  @Input() paginationPageNumber: number;
  @Input() paginationMaxPagesNumber: number;
  @Input() paginationItemsPerPageDisplayValue: number;
  @Input() paginationLevels: ISelectOptions[];

  @Output() decrementPagination = new EventEmitter();
  @Output() incrementPagination = new EventEmitter();
  @Output() navigateToStartingPage = new EventEmitter();
  @Output() navigateToEnd = new EventEmitter();
  @Output() itemsPerPage: EventEmitter<number> = new EventEmitter<number>();

  decrementPaginationPage() {
    this.decrementPagination.emit();
  }

  incrementPaginationPage() {
    this.incrementPagination.emit();
  }

  goToFirstPage() {
    this.navigateToStartingPage.emit();
  }

  goToLastPage() {
    this.navigateToEnd.emit();
  }

  changePaginationItemsPerPage(event: number) {
    this.itemsPerPage.emit(event);
  }
}
